@switch (columnName) {
  @case ('status') {
    <app-ui-pill [customLabel]="true" [name]="getReadReceiptStatusPillClass(element)">
      {{ element.status | translate }}
    </app-ui-pill>
  }
  @case ('currentEmploymentDepartment') {
    {{ element.currentEmploymentDepartment.name }}
  }
  @default {
    <app-default-cell [columnName]="columnName" [element]="element"></app-default-cell>
  }
}
